"use strict";
var appn;
(function (appn) {
    var views;
    (function (views) {
        var provider;
        (function (provider) {
            var verifysendgriddomain;
            (function (verifysendgriddomain) {
                function init() {
                    $('.dnsrecord-link-copy-btn').on('click', function (e) {
                        e.preventDefault();
                        let textToCopy = $(this);
                        textToCopy.select();
                        navigator.clipboard.writeText(textToCopy.val());
                    });
                }
                verifysendgriddomain.init = init;
            })(verifysendgriddomain = provider.verifysendgriddomain || (provider.verifysendgriddomain = {}));
        })(provider = views.provider || (views.provider = {}));
    })(views = appn.views || (appn.views = {}));
})(appn || (appn = {}));
